module.exports = __webpack_public_path__ + "img/bottle_of_felicis.68f7fd6d.jpg";